/* Results timeline: "ההסבר המלא" expanders. In the milestones the full text
   sits ABOVE its button (Figma), which a <details> can't do, so a button
   toggles the panel (the callout and the terms open below their button). The open /
   close is a grid-rows transition, same timing as the FAQ accordions. */
(() => {
  if (window.drResultsTimelineInit) return;
  window.drResultsTimelineInit = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.dr-Timeline__more');
    if (!button) return;
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;

    const open = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', String(open));
    panel.classList.toggle('is-open', open); // CSS animates the rows (like the FAQ accordions)

    const label = button.querySelector('.dr-Timeline__more-label');
    if (label) label.textContent = open ? button.dataset.labelLess : button.dataset.labelMore;

    // Closing a long panel would leave the reader far below the milestone:
    // bring the button back into view.
    if (!open && button.getBoundingClientRect().top < 0) {
      button.scrollIntoView({ block: 'center' });
    }
  });
})();
